import { useTranslation } from "react-i18next";
import CustomButton from "./CustomButton";
import CustomInput from "./CustomInput";
import SectionDivider from "./SectionDivider";
import addIcon from "../assets/add_icon.png";
import FilesUpload from "./FileUpload";

const OtherDocsSection = ({ otherFiles, setOtherFiles }) => {
  const { t } = useTranslation("general");

  const handleFileChange = (newFile, fileId) => {
    setOtherFiles((prev) =>
      prev.map((f) => (f.id === fileId ? { ...f, file: newFile } : f)),
    );
  };

  const handleDeleteFile = (fileId) => {
    setOtherFiles((prev) => prev.filter((f) => f.id !== fileId));
  };

  const handleValueChange = (value, fileId) => {

    // the restriction of the Arabic characters
    // if (/[\u0600-\u06FF]/.test(value)) return;

    setOtherFiles((prev) =>
      prev.map((f) => (f.id === fileId ? { ...f, value } : f)),
    );
  };

  const handleAddOtherDoc = () => {
    setOtherFiles((prev) => [
      ...prev,
      { id: `otherDoc-${Date.now()}`, value: "", file: null },
    ]);
  };

  return (
    <div className="o-column u-margin--top_200">
      <SectionDivider title={t("otherDocs")} noMargin={true} />

      <div className="u-margin--top_500 o-column o-column--gap-size_500">
        {otherFiles.map((file) => (
          <div key={file.id}>
            <span>{t("docName")}: </span>
            {file.file && <div className="u-margin--top_100">{file.value}</div>}
            {!file.file && (
              <CustomInput
                value={file.value}
                onChange={(e) => handleValueChange(e.target.value, file.id)}
                disabled={file.file}
              />
            )}
            <FilesUpload
              file={file.file}
              onFileChange={(newFile) => handleFileChange(newFile, file.id)}
              disabled={!file.value}
              onDeleteFile={() => handleDeleteFile(file.id)}
              label={file.value || t("uploadDocument")}
              accept=".pdf,application/pdf"
            />
          </div>
        ))}
      </div>
      <div className="u-margin--top_500" />
      <CustomButton
        title={t("addOtherDoc")}
        onClick={handleAddOtherDoc}
        variant={"blank"}
        icon={addIcon}
        iconSize={20}
      />
    </div>
  );
};

export default OtherDocsSection;